module.exports = __webpack_public_path__ + "img/gyro.71a19668.svg";